/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
// Component: D1maE2RgYRQ-
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectcss
import sty from "./PlasmicContainer.module.css"; // plasmic-import: D1maE2RgYRQ-/css

createPlasmicElementProxy;

export const PlasmicContainer__VariantProps = new Array("width");

export const PlasmicContainer__ArgProps = new Array("colContent");

const $$ = {};

function PlasmicContainer__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "width",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.width
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"everythingCtnrS0"}
      data-plasmic-override={overrides.everythingCtnrS0}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_cGVJnrZBpZGCmuty7FxDYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.everythingCtnrS0
      )}
    >
      <div
        data-plasmic-name={"colWrapper"}
        data-plasmic-override={overrides.colWrapper}
        className={classNames("all", sty.colWrapper, {
          [sty.colWrapperwidth_large]: hasVariant($state, "width", "large"),
          [sty.colWrapperwidth_medium]: hasVariant($state, "width", "medium"),
          [sty.colWrapperwidth_small]: hasVariant($state, "width", "small")
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.colContent
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  everythingCtnrS0: ["everythingCtnrS0", "colWrapper"],
  colWrapper: ["colWrapper"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContainer__ArgProps,
          internalVariantPropNames: PlasmicContainer__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContainer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "everythingCtnrS0") {
    func.displayName = "PlasmicContainer";
  } else {
    func.displayName = `PlasmicContainer.${nodeName}`;
  }
  return func;
}

export const PlasmicContainer = Object.assign(
  // Top-level PlasmicContainer renders the root element
  makeNodeComponent("everythingCtnrS0"),
  {
    // Helper components rendering sub-elements
    colWrapper: makeNodeComponent("colWrapper"),
    // Metadata about props expected for PlasmicContainer
    internalVariantProps: PlasmicContainer__VariantProps,
    internalArgProps: PlasmicContainer__ArgProps
  }
);

export default PlasmicContainer;
/* prettier-ignore-end */
